import { render, staticRenderFns } from "./PlaceCardInfo.vue?vue&type=template&id=5c18efd0&"
import script from "./PlaceCardInfo.vue?vue&type=script&lang=js&"
export * from "./PlaceCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports